<template>
  <div class="container">
    
    <BuerArticle v-if="unlocked"></BuerArticle>

    <!-- 验证码模态弹窗 -->
    <div v-if="!unlocked" class="modal">
      <div class="modal-content">
        <h3>请输入验证码</h3>
        <div><input v-model="captchaInput" placeholder="请输入验证码" @keyup.enter="verify" /></div>
        <button @click="verify">提交</button>
        <p v-if="error" style="color: red">验证码错误，请重试。</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import BuerArticle from './components/BuerArticle.vue'

const unlocked = ref(false)
const captchaInput = ref('')
const error = ref(false)

const verify = () => {
  const now = new Date().toLocaleDateString('zh-CN',{
    timeZone: 'Asia/Shanghai',
    hour12: false, // Use 24-hour format
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })

  const inputValue = captchaInput.value

  // 发起 POST 请求，把数据存入 KV
  fetch('/api/visitor-count', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ key: now, value: inputValue })
  });
  
  // 验证码逻辑
  if (inputValue.trim().toLowerCase() === 'iwyast' || inputValue.trim().toLowerCase() === 'czyqwen') {
    unlocked.value = true
    error.value = false
  } else {
    error.value = true
  }
}
</script>

<style scoped>
body, html {
  margin: 0;
  background-color: #fdf6e3;
  font-family: Arial, sans-serif;
}

.container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}


/* 弹窗 */
.modal {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: #fdf6e3; /* 整个页面背景 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.modal-content {
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, Helvetica, STKaiti, SimSun, serif;
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}

.modal-content h3 {
  margin-bottom: 10px;
}

input {
  padding: 10px;
  width: 100%;
  max-width: 300px;
  font-size: 16px;
  box-sizing: border-box;
}

button {
  margin-top: 8px;
  padding: 5px 16px;
  font-size: 1em;
  cursor: pointer;
}
</style>
